.list {
  width: 100%;
}
